const Cancel = function () {
  this.addPermission.resetAddPermissionModal()
}

export default Cancel
